/* global angular */
var Utils = require('@amzn/aws-workdocs-web-client-common').Utils;

(function (angular) {
    'use strict';

    /**
     * @ngdoc service
     * @name DocumentDropdownController
     *
     * @description
     * DocumentDropdownController is a base class checkin/checkout functionality inherited by FileBrowserController and DocumentControllers
     */
    angular.module('GorillaBoy')
    .factory('DocumentDropdownController', [
        '$rootScope',
        '$log',
        '$translate',
        'AppConstants',
        'BrowserService',
        'CompanionClientService',
        'CompanionService',
        'EndpointConfig',
        'FeatureManagerService',
        'Features',
        'localStorageService',
        'SourceConstant',
        '$timeout',
        DocumentDropdownController
    ]);
    function DocumentDropdownController($rootScope, $log, $translate, AppConstants, BrowserService, CompanionClientService, CompanionService, EndpointConfig, FeatureManagerService, Features, localStorageService, SourceConstant, $timeout) {
        var $scope = null,
            userInfo = null;
        return {
            initScope : initScopeFn
        };

        function initScopeFn(scopeVal, userInfoVal) {
            var OSTypes = AppConstants.OSTypes;
            $scope = scopeVal;
            userInfo = userInfoVal;
            $scope.$on('$destroy', function() {
                $scope = null;
                userInfo = null;
            });
            $scope.companionDownloadUrl = CompanionService.getCompanionDownloadUrl();
            $scope.getEditDisabledReason = function(doc) {
                // Notice: For each of the reason in canEdit (except feature is disabled), this method must return a reason for it.
                // Thus, whether or not this method returns a string can be used to determine if file is editable.  

                var msg;
                var os = BrowserService.getOS(),
                isOSSupported = [OSTypes.WINDOWS, OSTypes.MAC].indexOf(os) > -1,
                MAC_COMPANION_MIN_VERSION = '1.0.81.0';

                if ($scope.isDocumentCheckedOutByAnApp(doc)) {
                    return $translate.instant('FILE_ACTIONS.EDIT_DROPDOWN.LOCAL_EDIT_DISABLED_DUE_TO_LOCK');
                }

                // The order matters. Do checks for preventing companion from loading first.
                if (BrowserService.isMobileOrTablet()) {
                    msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.DEVICE_NOT_SUPPORTED');
                } else if (!isOSSupported) {
                    msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.OS_NOT_SUPPORTED');
                } else if($scope.isDocumentCheckedOutByOtherUser(doc)) {
                    msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.NOT_EDITABLE_WHILE_LOCKED_BY_OTHERS');
                } else if (!$scope.userActionsMap[doc.Id].canDownload) {
                    msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.NOT_EDITABLE_WHILE_DOWNLOAD_DISABLED');
                } else if (!$scope.userActionsMap[doc.Id].canUpload) {
                    msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.NOT_EDITABLE_WHILE_UPLOAD_DISABLED');
                } else if (!CompanionService.isCompanionConnectionPossible()) {
                    // If companion connection is not possible (which means browser is not supported), enable user to click edit so that companionDownloadDialog can be shown
                    // This condition check must happens before any other check that requires companion's state
                    return msg;
                } else if (!$rootScope.companionDownloadButtonClicked && EndpointConfig.isPreviewSite() && BrowserService.getOS() === AppConstants.OSTypes.MAC &&
                    (Utils.compareVersion(MAC_COMPANION_MIN_VERSION, CompanionClientService.getClient().getCompanionVersion()) > 0)) {
                    msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.OLD_COMPANION', {companionDownloadUrl: $scope.companionDownloadUrl});
                }
                return msg;
            };

            $scope.markCompanionAsInstalled = function() {
                $rootScope.companionDownloadButtonClicked = true;
                $timeout(function() {
                    if ($scope.userActionsMap) {
                        $scope.userActionsMap = {};
                    }
                });
            };
        }
    }

}(angular));